import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { useApiClient } from '~/api-client';
import { MapViewsResource } from '@mark43/cad-api';
import { EsriTokenWithExpiry } from '../esri-identity';

export function useEsriTokenApi(): () => Promise<EsriTokenWithExpiry> {
    const apiClient = useApiClient();

    return React.useCallback(async (): Promise<EsriTokenWithExpiry> => {
        const response = await apiClient.request<MapViewsResource.GetEsriToken>({
            method: 'POST',
            url: 'map_views/get_esri_token',
        });
        const data = response.data.data;
        if (!data) {
            throw new Error('Esri token endpoint returned no data');
        }
        return data;
    }, [apiClient]);
}
